// extracted by mini-css-extract-plugin
export default {"dialog_device":"DeviceModal_dialog_device__wRaQX","btn_cancel":"DeviceModal_btn_cancel__XSOYD","btn_save":"DeviceModal_btn_save__WzDcT"};